import { render, staticRenderFns } from "./BrandItem.vue?vue&type=template&id=64add017&scoped=true&"
import script from "./BrandItem.vue?vue&type=script&lang=ts&"
export * from "./BrandItem.vue?vue&type=script&lang=ts&"
import style0 from "./BrandItem.vue?vue&type=style&index=0&id=64add017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64add017",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64add017')) {
      api.createRecord('64add017', component.options)
    } else {
      api.reload('64add017', component.options)
    }
    module.hot.accept("./BrandItem.vue?vue&type=template&id=64add017&scoped=true&", function () {
      api.rerender('64add017', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/BrandItem.vue"
export default component.exports